import { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { TextField, MessageBar, MessageBarType, PrimaryButton, Dropdown } from 'office-ui-fabric-react';
import { History } from "history";
import * as _yup from "yup";
import 'react-sortable-tree/style.css';
import _ from "lodash";
import slugify from 'slugify';
import { RootState } from 'app/redux/reducer';
import { createSpecification, getSpecificationTypes, ISpecification } from 'app/services/specification';
import { initialPageData, setPageData, setPageErrors } from 'app/redux/page/actions';
import { StatusEnum } from 'app/shared';
import { castThunkAction } from 'app/utils/casting';
import PageTitle from 'components/customs/PageTitle';
import Sidebar from 'components/customs/Sidebar/Sidebar';
import PageLayout from 'containers/PageLayout';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
    history: History<any>;
}

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        language: state.system.language,
        pageData: state.page.pageData as ISpecification,
        pageErrors: state.page.pageErrors,
        contentTypes: state.contentType.contentTypes.list,
        specificationTypes: state.specification.specificationTypes
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        ...bindActionCreators({
            setPageData,
            setPageErrors,
            initialPageData,
            createSpecification,
            getSpecificationTypes
        }, dispatch)
    };
}

type CreateSpecificationProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

interface OwnState {
    messageType: MessageBarType;
}

class CreateSpecification extends Component<CreateSpecificationProps, OwnState> {

    state = {
        messageType: MessageBarType.warning
    }

    componentDidMount() {
        this.resetData();
        this.props.getSpecificationTypes({ page: 1, pageSize: 1000, descending: false });
    }

    onValueChange(index: number, key: string, value: string) {
        const clonedItems = _.cloneDeep(this.props.pageData?.values || []);
        if (!clonedItems[index]) {
            clonedItems[index] = {
                ...clonedItems[index],
                [key]: value
            }
        }
        else {
            clonedItems[index][key] = value;
        }
        this.props.setPageData("values", clonedItems);
    }

    resetData() {
        this.setState({
            messageType: MessageBarType.warning
        }, () => {
            this.props.initialPageData<ISpecification>({
                title: "",
                specificationTypeId: "",
                brandId: null,
                status: StatusEnum.Published,
                values: []
            })
        })
    }

    renderTextByMessageType() {
        switch (this.state.messageType) {
            case MessageBarType.success:
                return "Kaydetme işlemi başarıyla gerçekleşmiştir. Düzenleme sayfasına yönlendiriliyorsunuz..."
            case MessageBarType.error:
                return "Kayıt işlemi yapılırken bir hata oluşmuştur. Lütfen servis sağlayıcınızla iletişime geçin."
            default:
                return null;
        }
    }

    renderMessageBar() {
        if (this.state.messageType !== MessageBarType.warning)
            return (
                <MessageBar
                    messageBarType={this.state.messageType}
                    isMultiline={false}
                >
                    {this.renderTextByMessageType()}
                </MessageBar>
            )
        return null;
    }

    /**
     * Validation Şemasını Kontrol Ederek, Eğer Validate ise Doğrulama modalını aktive eder, Değilse İlgili Yerlere Hata Dönecek Yani,
     * formErrors Objesini Dolduracak Action'u Tetikler.
     */
    onSubmit(isDraft?: boolean) {
        const {
            pageData,
            setPageErrors
        } = this.props;
        const validationSchema = _yup.object({
            title: _yup.string().required(
                "Bu alan zorunludur!"
            )
        });
        let formErrors = {};
        validationSchema
            .validate(pageData, {
                abortEarly: false
            })
            .then(() => {
                setPageErrors({});
                castThunkAction<ISpecification>(this.props.createSpecification({
                    ...this.props.pageData,
                    status: isDraft ? StatusEnum.Draft : StatusEnum.Published
                })).then(res => {
                    this.setState({
                        messageType: res?.id ? MessageBarType.success : MessageBarType.error
                    }, () => {
                        if (res?.id) {
                            setTimeout(() => {
                                this.props.history.push(`/specification/edit/${res.id}`)
                            }, 1200)
                        }
                    })

                })
            })
            .catch(err => {
                err.inner.forEach((e: any) => {
                    const { path, message } = e;
                    formErrors[path] = message;
                });
                setPageErrors(formErrors);
            });
    };


    renderForm() {
        const { pageData, pageErrors, setPageData } = this.props;
        return (
            <div className="form-groups" style={{ width: "calc(100% + 15px)" }}>
                <div style={{ paddingTop: 0, paddingRight: 0, }} className="form-group">
                    <div className="title-form row">
                        <TextField
                            placeholder="Spesifikasyon Adı"
                            value={pageData.title || ""}
                            label="Spesifikasyon Adı"
                            className="custom-textfield col-md-6 border"
                            errorMessage={pageErrors.title}
                            onChange={(event: any) => setPageData("title", event.target.value)}
                        />
                        <Dropdown
                            selectedKey={pageData.specificationTypeId || ""}
                            label="Spesifikasyon Kategorisi"
                            calloutProps={{ className: "custom-dropdown-callout" }}
                            className="custom-dropdown col-md-6 border"
                            onChange={(event: any, option) => setPageData("specificationTypeId", option?.key as string)}
                            options={(this.props.specificationTypes?.list || []).map(item => ({ key: item.id, text: item.title }))}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderValues() {
        const items = [...(this.props.pageData?.values || []), { name: "", value: "" }];
        return (
            <div className="form-wrapper page-values">
                <div className="meta-dropdown-values">
                    <div className="meta-dropdown-title row">
                        <div className="col">
                            <span className="title"> Kayıt Değeri</span>
                        </div>
                        <div style={{ marginLeft: "-30px" }} className="col">
                            <span className="title"> Kayıt Yazısı</span>
                        </div>
                    </div>
                    {items.map((item, index) => (
                        <div key={index} className="meta-dropdown-value row">
                            <TextField
                                className="custom-textfield col"
                                placeholder="Kayıt Değeri"
                                description="Bir değer yazınız"
                                styles={{ description: { color: "#6c6c6c !important", marginTop: "2px !important" } }}
                                value={item.name as string}
                                onChange={(event: any) => this.onValueChange(index, "name", slugify(event.target.value) as string)}
                            />
                            <TextField
                                className="custom-textfield col"
                                placeholder="Kayıt Yazısı"
                                styles={{ description: { color: "#6c6c6c !important", marginTop: "2px !important" } }}
                                description="Seçilebilecek yerlerde gözükecek yazı yazınız"
                                value={item.value as string}
                                onChange={(event: any) => this.onValueChange(index, "value", event.target.value as string)}
                            />
                            <i
                                onClick={() => {
                                    const clonedItems = _.cloneDeep(this.props.pageData?.values || []);
                                    clonedItems.splice(index, 1);
                                    this.props.setPageData("values", clonedItems);
                                }}
                                className={(index + 1) === items.length ? "icon-close passive" : "icon-close1"}
                            />

                        </div>
                    ))}
                </div>
            </div>
        )
    }

    renderContent() {
        return (
            <div className="menu-designer row">
                {this.renderForm()}
                {this.renderValues()}
            </div>
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Yeni Spesifikasyon Ekle"
                        titleRenderer={
                            () => (
                                <span className="edit-title">
                                    Yönet:
                                    <strong>Yeni Spesifikasyon Ekle</strong>
                                </span>
                            )
                        }
                        showBack
                        backUrl="/specifications"
                        history={this.props.history}
                        subTitle="Yeni bir spesifikasyon eklemek için aşağıdaki bilgileri doldurunuz, dilerseniz taslak olarakta oluşturabilirsiniz."
                    />
                    <PrimaryButton
                        onClick={() => { this.resetData() }}
                        iconProps={{ iconName: "Add" }}
                        className="absolute-create"
                        text="Yeni Spesifikasyon Ekle"
                        styles={{
                            root: {
                                background: "#62a98e",
                                borderColor: "#5b9e85",
                                color: "#fff"
                            },
                            rootHovered: {
                                background: "#5b9e85",
                                borderColor: "#5b9e85"
                            },
                            rootDisabled: {
                                background: "#ececec"
                            }
                        }}
                    />
                    <div className="content row">
                        <div className="left col no-padding">
                            {this.renderMessageBar()}
                            {this.renderContent()}
                        </div>
                        <Sidebar
                            categoryBar={{
                                hide: true
                            }}
                            publishBar={{
                                onSave: (isDraft) => this.onSubmit(isDraft),
                                disabledSaveButton: this.state.messageType === MessageBarType.success || !this.props.pageData?.title || !this.props.pageData?.specificationTypeId ? true : false,
                                hideDeleteButton: true,
                                hidePreviewButton: true
                            }}
                            layoutBar={{
                                hide: true
                            }}
                            archiveBar={{
                                hide: true
                            }}
                            thumbnailBar={{
                                hide: true
                            }}
                        />
                    </div>
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateSpecification);